import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.addLargeClass()
    document.addEventListener('turbo:render', this.addLargeClass)
  }
  
  disconnect() {
    document.removeEventListener('turbo:render', this.addLargeClass)
  }
  
  addLargeClass = () => {
    const element = document.getElementById('page-inner-content')
    if (element) {
      element.classList.add('page-inner--large')
    }
  }
}